import invoicePreview from './invoicePreview'
import participant from "./participant"
import start from './start'
import person from './person'
import questions from './questions'
import payment from './payment'
import summary from './summary'

export default {
    invoicePreview,
    participant,
    start,
    person,
    questions,
    payment,
    summary,
    order: "Bestellung",
    registration: "Anmeldung",
    booking: "Buchung",
    caution: "Achtung",
    previewActive: "Sie sehen diese Anmeldung im Vorschaumodus. Die Anmeldung ist möglicherweise noch nicht freigeschaltet.",
    next: "Weiter",
    bookNowPayable: "Jetzt zahlungspflichtig buchen",
    bookNow: "Jetzt buchen",
    buyNow: "Jetzt zahlungspflichtig bestellen",
    saveGroupRegistration: "Gruppenanmeldung speichern",
    saveGroupBuy: "Gruppenbestellung speichern",
    orderNow: "Jetzt bestellen",
    someErrors: "Etwas stimmt noch nicht!",
    someErrorsExplanation: "Bitte korrigieren Sie folgende Felder:",
    done: "Fertig",
    someErrorsExplanationRegStepPage: "Bevor Sie zum nächsten Schritt gehen können, müssen Sie noch folgende Fehler korrigieren:",
    clickExplanation: "(Ein Klick auf eine der Schaltfächen, führt Sie zu dem fehlerhaften Feld)",

    registrationState: 'Status Ihrer Anmeldung',
    newsletterAlreadySubscribedMessage: 'Sie sind bereits für unseren Newsletter angemeldet.',
    newsletterSubscriptionErrorMessage: 'Es ist ein Fehler bei der Anmeldung zum Newsletter aufgetreten. Bitte versuchen Sie es später erneut.',
    subscriptionSuccessful: "Ihre Anmeldung zum Newsletter war erfolgreich.",

    registrationSuccessful: "Ihre Anmeldung wurde erfolgreich an uns übermittelt.",
    startOfGroupRegistrationSuccessful: "Ihre Gruppenanmeldung wurde erfolgreich erstellt.",
    groupRegistrationSavedSuccessful: "Ihre Gruppenanmeldung wurde erfolgreich gespeichert.",
    editGroupRegistration: "Gruppenanmeldung bearbeiten",
    yourRegistrationNumber: "Ihre Anmeldungsnummer lautet",
    yourProcessNumber: "Ihre Vorgangsnummer lautet",
    requestFailed: "Ihre Anmeldung konnte nicht vollständig bearbeitet werden. Die Anfrage muss erst von der Sachbearbeitung manuell bearbeitet werden.",
    openPrintView: "Druckansicht Ihrer Anmeldung öffnen",
    requestProcessed: "Die Anmeldung wurde erfolgreich bearbeitet.",
    requestBeingProcessed: "Die Anmeldung wird in Kürze bearbeitet.",
    pleaseWait: "Sie können das Fenster schließen, da Ihre Anmeldung nun vom System im Hintergrund verarbeitet wird. Wenn " +
        "Sie das Fenster geöffnet lassen, sehen Sie nach der Verarbeitung anstelle der Vorgangsnummer Ihre tatsächliche Anmeldungsnummer.",
    requestNotFound: "Der Status Ihrer Anmeldung konnte nicht abgerufen werden.",
    processingSomeOpenRequests: "Wir bearbeiten zur Zeit noch andere Anfragen.",
    processingOpenRequests: "Wir bearbeiten zur Zeit ca. {openRequests} Anfragen.",

    noEventData: "Fehlerhafte Veranstaltungsdaten!",
    pleaseReloadPage: "Die Veranstaltung wurde nicht oder nur unvollständig geladen. Um Fehler zu vermeiden laden Sie bitte die Seite neu!",
    pleaseReloadPageForVersion: "Sie arbeiten mit einer veralteten Version der Onlineanmeldung. Um Fehler zu vermeiden laden Sie bitte die Seite neu!",
    deprecatedVersion: "Veraltete Anmeldungsseite",

    loadingDocument: "Ihr Dokument wird geladen",
    eventPrintView: "Druckansicht Ihrer Veranstaltung",
    eventPreContractualInfo: "Vorvertragliche Informationen Ihrer Veranstaltung",
    eventOverview: "Übersicht Veranstaltung",
    justOverview: "Übersicht",

    dontLeaveOpenRegistration: "Ihre Anmeldung wurde noch nicht abgesendet. Wenn Sie die Seite verlassen, gehen Ihre Daten verloren. Möchten Sie die Seite wirklich verlassen?",
    submitBlocked: "Bitte warten Sie {seconds}s",
    submitBlockedExplanation: "Es gehen im Moment zu viele Anfragen an diese Onlineanmeldung ein. ",
    submitBlockedExplanationSecond: "Bitte warten Sie einen Moment und versuchen Sie es dann erneut.",
    submitBlockedExplanationThird: "Laden Sie die Seite nicht neu, da sonst Ihre Anmeldedaten verloren gehen.",

}
